document.addEventListener('DOMContentLoaded', () => {
  function processHighlights(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue;
      const regex = /(===)(.*?)\1|(==)(.*?)\3/g;
      
      if (regex.test(text)) {
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        
        // Use replace but actually just to iterate over matches
        text.replace(regex, (match, isHalfStart, halfText, isFullStart, fullText, offset) => {
          // Append text before match
          if (offset > lastIndex) {
            fragment.appendChild(document.createTextNode(text.substring(lastIndex, offset)));
          }
          
          const span = document.createElement('span');
          if (isHalfStart) {
            span.className = 'highlight-half';
            span.textContent = halfText;
          } else {
            span.className = 'highlight-full';
            span.textContent = fullText;
          }
          fragment.appendChild(span);
          
          lastIndex = offset + match.length;
          return match;
        });
        
        // Append remaining text
        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
        }
        
        node.parentNode.replaceChild(fragment, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName !== 'SCRIPT' && node.nodeName !== 'STYLE' && node.nodeName !== 'NOSCRIPT') {
      // Create an array of child nodes to iterate over safely, as we might modify them
      Array.from(node.childNodes).forEach(processHighlights);
    }
  }

  processHighlights(document.body);
  
  // Observe DOM mutations to apply highlight on dynamic content (e.g., Shopify sections loaded via AJAX)
  const observer = new MutationObserver(mutations => {
    let shouldProcess = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldProcess = true;
        break;
      }
    }
    
    if (shouldProcess) {
      // Small debounce to avoid freezing on massive DOM updates
      clearTimeout(window._highlightTimeout);
      window._highlightTimeout = setTimeout(() => {
        processHighlights(document.body);
      }, 50);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});
